import { createSelector } from '@reduxjs/toolkit';

const oemsState = ({ oems }) => oems;

export const selectAllOemsState = createSelector(oemsState, ({ oems }) => ({ oems }));
